module.exports = __webpack_public_path__ + "img/wlx_code_1.eddd1e94.png";